export default __webpack_public_path__ + "static/media/bigpanda.befe0af2.svg";